import { Component, OnInit, Input, AfterViewInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { FeeColumnFilterPanelService, PlayerAdjustmentService, MemberService } from '../../../../services';
import { AppState, Store, take, map, AppFields, combineLatest, Club } from '../../../../store';
import { UserInfo } from '../../../../interfaces';
import { AddMakeQuickPayment } from '../../../../add-make-quick-payment';
import { EmailMessageOptions } from '../../../../email-mesage-options';
import { AlertService } from '../../../../services/alert.service';

@Component({
  selector: 'app-make-quick-payment',
  templateUrl: './make-quick-payment.component.html',
  styleUrls: ['./make-quick-payment.component.css']
})
export class MakeQuickPaymentComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('cardInfo') cardInfo: ElementRef;
  public card: any;
  public cardHandler = this.onChange.bind(this);
  public error: string;
  public quickPayForm: FormGroup;
  public validationMessages = {};

  @Input() ClubUserProgramFeeID: number;
  @Input() ClubProgramFeeID: string;
  @Input() ClubProgramID: string;
  @Input() UserId: number;
  @Input() FirstName: string;
  @Input() MiddleName: string;
  @Input() LastName: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService,
    private cd: ChangeDetectorRef,
    private memberService: MemberService,
    private alertService: AlertService,
    private store: Store<AppState>
  ) {
    this.validationMessages = {
      'Required': 'This field is required.'
    };
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.quickPayForm = this.fb.group({
      Amount: ['', [Validators.required]]
    });
  }
  isAmountValid() {
    return this.quickPayForm.get('Amount').errors
      && (this.quickPayForm.get('Amount').touched
        || this.quickPayForm.get('Amount').dirty);
  }

  validateUi() {
    Object.keys(this.quickPayForm.controls).forEach(field => {
      const control = this.quickPayForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  /* =================================== STRIPE UI =================================== */
  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }
  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }
  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }
  async onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      const { token, error } = await stripe.createToken(this.card);
      if (error) {
        console.log('Something is wrong:', error);
        this.error = error.message;
      } else {
        console.log('Success!', token);

        event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
        event.target.disabled = true;
        const data: AddMakeQuickPayment = this.saveToken(token);
        combineLatest(
          this.store.select(AppFields.App, AppFields.User),
          this.store.select(AppFields.App, AppFields.Club),
          (user: UserInfo, club: Club) => {
            data.clubID = club.clubID;
            data.addedBy = user.userID;
            data.description = 'Club Billing - Quick Payment';

            console.log('addedBy - ', data.addedBy);
            console.log('Club Program ID - ', this.ClubProgramID);



            this.memberService.saveMakeQuickPayment(data).subscribe((qucikPaymentID: any) => {
              event.target.innerHTML = 'Save';
              event.target.disabled = false;
              this.clearForm();
              this.closeSideOverlay();

              // START: SEND PAYMENT CONFIRMATION EMAIL
              const emailOptions: EmailMessageOptions = {
                paymentID: qucikPaymentID,
                note: 'Thank you!',
                tgsMessageId: 3 // Payment Completed
              };

              this.memberService.sendEmailMessage(Number(this.ClubProgramID), data.clubID, this.UserId, emailOptions).subscribe(() => {
                console.log('Email queued!');
              }, error => {
                console.log('Email could not be queued - ', error);
              });
              // START: SEND PAYMENT CONFIRMATION EMAIL
              this.alertService.success('Your payment has been saved successfully.');
            }, e => {
              this.alertService.error(e.error);
            });
          }
        ).pipe(take(1)).subscribe();
      }
    } else {
      this.validateUi();
    }
  }
  /* ================================= END STRIPE UI ================================== */

  saveToken(token) { // TODO - Need to add more object properties and thier values
    const obj = {
      ClubUserProgramFeeID: this.ClubUserProgramFeeID,
      amount: this.quickPayForm.value.Amount,
      userID: this.UserId,
      stripeToken: token.id,
      cardType: token.card.brand,
      fullName: this.LastName + ' ' + this.FirstName + ' ' + this.MiddleName,
      maskedCCNum: token.card.last4.toString(),
      expDate: token.card.exp_month + '/' + token.card.exp_year,
      // cvc: document.getElementsByName("cvc"),
      cvc: 0, // TODO: dynamic
      isDefault: 0
    };
    // console.log(obj);
    return obj;
  }

  clearForm() {
    this.quickPayForm.markAsUntouched();
    // this.quickPayForm.updateValueAndValidity();
    this.card.clear();
    this.quickPayForm.reset();
    this.closeSideOverlay();
  }

  onReset(event) {
    event.stopPropagation();
    this.clearForm();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/make-quick-payment/make-quick-payment.component.ts